import React from "react";
import { BarChart, CartesianGrid, XAxis, YAxis, Legend, Bar, Tooltip, ResponsiveContainer } from "recharts";
import { Select } from "@mantine/core";
import { tokens } from "@blurb/codex-react";
import { Body, Heading } from "../../../components/Typography";
import { ChartTooltip } from "../../../components/graphs/ChartTooltip";
import { ChartLegend } from "../../../components/graphs/ChartLegend";
import { useStyles } from "./styles";
import { useYtdData } from "./useYtdData";
import { useYtdOrdersQuery } from "../../../mocks/graphql";
import { useAuthUser } from "../../../hooks/useAuthUser";

export const YtdOrdersChart: React.FC = () => {
  const user = useAuthUser();
  const { classes } = useStyles();
  const { data, isLoading } = useYtdOrdersQuery({ customerPublicId: user.id! });
  const { yearData, selectProps } = useYtdData({ isLoading, data: data?.yearlyOrderMetrics });

  return (
    <div className={classes.chartContainer}>
      <div className={classes.chartHeader}>
        <Heading size="lg">Orders</Heading>
        <Select className={classes.chartSelect} {...selectProps} />
      </div>
      <Body className={classes.chartSubheader}>Year-to-date</Body>
      <ResponsiveContainer className={classes.chart}>
        <BarChart data={yearData?.months || []}>
          <CartesianGrid />
          <XAxis dataKey="month" axisLine={false} />
          <YAxis
            width="auto"
            tickCount={6}
            domain={[0, 250]}
            tickLine={false}
            axisLine={false}
            tickFormatter={(value) => value} // This fixes a bug where the tick values just don't show up
          />
          <Tooltip
            content={(props) => <ChartTooltip {...props} label={props?.payload?.[0]?.payload.month} />}
            cursor={{
              fill: tokens.color.semantic.bg.neutralInverseHover,
              fillOpacity: 0.06,
            }}
          />
          <Legend content={ChartLegend} />
          <Bar
            dataKey="shipped"
            name="Shipped"
            stackId="a"
            fill={tokens.color.primitive.light.dataVisualization.green}
          />
          <Bar
            dataKey="printing"
            name="Printing"
            stackId="a"
            fill={tokens.color.primitive.light.dataVisualization.blue}
          />
          <Bar
            dataKey="inProgress"
            name="In Progress"
            stackId="a"
            fill={tokens.color.primitive.light.dataVisualization.orange}
          />
          <Bar
            dataKey="failed"
            name="Failed"
            stackId="a"
            fill={tokens.color.primitive.light.dataVisualization.magenta}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
